import React, { useState} from 'react'
import axios from 'axios'
import './home.css';
import 'bootstrap/dist/css/bootstrap.css';
import './newmodal.css'

import Percentage from './percentage'
import POS_NEG from './pos_neg_text'
import Meter from './meter'
import Bar from './barchart'
import List from './list'
import Spinner from '../loader/loader'

const Dashboard = () => {

    const [data, setData] = useState([]);
    const [posPercent, setPosPercent] = useState(0);
    const [negPercent, setNegPercent] = useState(0);
    const [mostPos, setMostPos] = useState('')
    const [mostNeg, setMostNeg] = useState('')
    const [meterVal, setMeterVal] = useState(0)
    const [nPos, setNPos] = useState(0)
    const [nNeg, setNNeg] = useState(0)

    const [file, setFile] = useState('');
    const [fileName, setFileName] = useState('Choose File');

    // useEffect(() => {
    //     fetch_data()
    // }, [])

    const [algo, setAlgo] = useState('ft');
    const [loaded, setLoaded] = useState(true)






    // const fetch_data = async () => {
    //     const response = await fetch("http://127.0.0.1:5000/fake");
    //     const data = await response.json()
    //     setData(data)

    //     setPosPercent((data[data.length - 1].n_positive / data[data.length - 1].total_reviews) * 100)
    //     setNegPercent((data[data.length - 1].n_negetive / data[data.length - 1].total_reviews) * 100)


    //     const mostPosIndex = data[data.length - 1].most_positive_index
    //     const mostNegIndex = data[data.length - 1].most_negetive_index

    //     let posText = data.filter(e => {
    //         return e.index === mostPosIndex
    //     })

    //     let negText = data.filter(e => {
    //         return e.index === mostNegIndex
    //     })

    //     setMostPos(posText[0].text)
    //     setMostNeg(negText[0].text)

    //     setMeterVal(data[data.length - 1].meter)

    //     setNPos(data[data.length - 1].n_positive)
    //     setNNeg(data[data.length - 1].n_negetive)
    // }

    const _handleModalClick = (event) => {
        var modal = document.getElementById("myModal");

        // Get the button that opens the modal
        var btn = document.getElementById("myBtn");

        // Get the <span> element that closes the modal
        var span = document.getElementsByClassName("close")[0];

        // When the user clicks on the button, open the modal
        btn.onclick = function () {
            modal.style.display = "block";
        }

        // When the user clicks on <span> (x), close the modal
        span.onclick = function () {
            modal.style.display = "none";
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function (event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        }
    }


    const onChange = (e) => {
        setFile(e.target.files[0])
        setFileName(e.target.files[0].name)
    }

    const onSubmit = async (e) => {
        e.preventDefault()

        const formData = new FormData()
        formData.append('file', file)
        formData.append('algo', algo)

        try {

            setLoaded(false)
            const res = await axios.post('https://analytica-api.herokuapp.com/predict', formData, { crossdomain: true })

            const data = await res.data
            console.log(data)

            setData(data)

            setPosPercent((data[data.length - 1].n_positive / data[data.length - 1].total_reviews) * 100)
            setNegPercent((data[data.length - 1].n_negetive / data[data.length - 1].total_reviews) * 100)

            setLoaded(true)
            const mostPosIndex = data[data.length - 1].most_positive_index
            const mostNegIndex = data[data.length - 1].most_negetive_index

            let posText = data.filter(e => {
                return e.index === mostPosIndex
            })

            let negText = data.filter(e => {
                return e.index === mostNegIndex
            })

            setMostPos(posText[0].text)
            setMostNeg(negText[0].text)

            setMeterVal(data[data.length - 1].meter)

            setNPos(data[data.length - 1].n_positive)
            setNNeg(data[data.length - 1].n_negetive)
        } catch (error) {

        }
    }

    const closem = (event) => {
        var modal = document.getElementById("myModal");

        modal.style.display = "none";

    }

    const _handleAlgoChange = (event) => {
        setAlgo(event.target.value)
    }

    return (


        <>
            {
                (() => {
                    switch (loaded) {
                        case true: return (
                            <>

                            <div className="dashboard-wrapper">
                                <div className="dashboard">
                                    <div>
                                        <center><button id="myBtn" onClick={_handleModalClick} className="btn btn-primary btn-large mb-3">Upload a File</button></center>
                
                
                                        <div id="myModal" class="modal">
                
                
                                            <div class="modal-content">
                                                <span class="close">&times;</span>
                                                <form className="upload-form" onSubmit={onSubmit}>
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" name="file" id="customFile" accept=".csv" required onChange={onChange} />
                                                        <label class="custom-file-label" for="customFile">{fileName}</label>
                                                    </div>
                                                    <div class="custom-file form-group">
                                                        <label htmlFor="algo">Choose Algorithm</label>
                                                        <select name="algo" id="algo" className="form-control" onChange={_handleAlgoChange}>
                                                            <option value="lr">Logistic Regression 89% Accuracy</option>
                                                            <option value="mnb">Multinomial Naive Bayes 84% Accuracy</option>
                                                        </select>
                                                    </div>
                                                    <center>
                                                        <button type="submit" className="text-center btn btn-primary btn-lg mt-5" onClick={closem}>Upload</button>
                                                    </center>
                                                </form>
                                            </div>
                
                                        </div>
                                    </div>
                                    <div className="row-1">
                                        <div className="percentage">
                                            <Percentage pos={posPercent} neg={negPercent} />
                                        </div>
                                        <div className="count-graph">
                                            <Bar n_neg={nNeg} n_pos={nPos} />
                                        </div>
                                    </div>
                
                                    <div className="row-2">
                                        <div className="most-pos-neg-text">
                                            <center>
                                                <POS_NEG posText={mostPos} negText={mostNeg} />
                                            </center>
                                        </div>
                                        <div className="meter">
                                            <Meter val={meterVal} />
                                        </div>
                                    </div>
                                    {
                                        data.map(function (datum, idx) {
                                            if (idx !== data.length - 1) {
                                                return (<List text={datum.text} lable={datum.lable} confidence={datum.confidence} />)
                                            }
                                        })
                                    }
                                </div>
                            </div>
                
                
                
                        </>
                        )

                        case false: return (<Spinner />)

                        default: return (
                            <>

                            <div className="dashboard-wrapper">
                                <div className="dashboard">
                                    <div>
                                        <center><button id="myBtn" onClick={_handleModalClick} className="btn btn-primary btn-large mb-3">Upload a File</button></center>
                
                
                                        <div id="myModal" class="modal">
                
                
                                            <div class="modal-content">
                                                <span class="close">&times;</span>
                                                <form className="upload-form" onSubmit={onSubmit}>
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" name="file" id="customFile" accept=".csv" required onChange={onChange} />
                                                        <label class="custom-file-label" for="customFile">{fileName}</label>
                                                    </div>
                                                    <div class="custom-file form-group">
                                                        <label htmlFor="algo">Choose Algorithm</label>
                                                        <select name="algo" id="algo" className="form-control" onChange={_handleAlgoChange}>
                                                            <option value="lr">Logistic Regression 89% Accuracy</option>
                                                            <option value="mnb">Multinomial Naive Bayes 84% Accuracy</option>
                                                        </select>
                                                    </div>
                                                    <center>
                                                        <button type="submit" className="text-center btn btn-primary btn-lg mt-5" onClick={closem}>Upload</button>
                                                    </center>
                                                </form>
                                            </div>
                
                                        </div>
                                    </div>
                                    <div className="row-1">
                                        <div className="percentage">
                                            <Percentage pos={posPercent} neg={negPercent} />
                                        </div>
                                        <div className="count-graph">
                                            <Bar n_neg={nNeg} n_pos={nPos} />
                                        </div>
                                    </div>
                
                                    <div className="row-2">
                                        <div className="most-pos-neg-text">
                                            <center>
                                                <POS_NEG posText={mostPos} negText={mostNeg} />
                                            </center>
                                        </div>
                                        <div className="meter">
                                            <Meter val={meterVal} />
                                        </div>
                                    </div>
                                    {
                                        data.map(function (datum, idx) {
                                            if (idx !== data.length - 1) {
                                                return (<List text={datum.text} lable={datum.lable} confidence={datum.confidence} />)
                                            }
                                        })
                                    }
                                </div>
                            </div>
                
                
                
                        </>
                        )
                    }
                })()
            }

        </>
    )
}

export default Dashboard